import React, { Fragment, useEffect, useState } from "react";
import { TENANT, TenantService } from "../../../managers/TenantManagerService";
import { getIncompleteFieldName } from "../../../managers/common/CommonUtil";
import RouteManager, { PAGE_ROUTES } from "../../../managers/RouteManager";
import {
    DKButton,
    DKLabel,
    DKIcon,
    DKTooltipWrapper,
  } from "deskera-ui-library";
import {
    isModuleRestricted,
	MODULE_ACCESS,
} from "../../module-access-control/ModuleAccessControlConstants";
import Utility, { removeDelayedLoader, showDelayedLoader } from "../../../utility/Utility";
import ShiftManagementService from "../../../services/ShiftManagementService";
import { fetchShifts, selectShifts } from "../../../Redux/Slices/ShiftManagementSlice";
import { useDispatch, useSelector } from "react-redux";
import ShiftUtils from "../../shift_management/ShiftUtils";
import ic_info_message from "../../../assets/icons/ic_info_gray01.png";
import { fetchEmployeeDetails, selectEmployeeData } from "../../../Redux/Slices/EmployeeListSlice";
import { useTranslation } from "react-i18next";
import { getCompensation } from "../../configs/config";
import { NONE_OPTION } from "../../../constants/Constant";
import { selectModuleAccessControl } from "../../../Redux/Slices/ModuleAccessControlSlice";
import EmployeeListService from "../../../services/EmployeeListService";
import MaskInputUtil from "../../../SharedComponents/MaskInput/MaskInputUtil";

function UserDetails(props) {
    const { t } = useTranslation();

	const isAdmin = TenantService.get(TENANT.IS_ADMIN);
	const isShiftManagementEnabled = TenantService.get(TENANT.IS_SHIFT_MANAGEMENT_ENABLED);

    const dispatch = useDispatch();

    const userDetails = useSelector(selectEmployeeData);
    const shifts = useSelector(selectShifts);
    const moduleAccessControl = useSelector(selectModuleAccessControl);

    const [userId, setUserId] = useState("");
    const [shiftDetails, setShiftDetails] = useState({});
    const [reportingManager, setReportingManager] = useState(NONE_OPTION.name);

    const [mask, setMask] = useState(MaskInputUtil.MASK_STATE);
    const maskUnmaskObservable = TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED) ? MaskInputUtil.subscripeToMaskUnmaskObservable((mask) => {
      setMask(mask);
    }) : null;

    useEffect(async () => {
        const tenantData = TenantService.getData();
        const userId = tenantData["USER_ID"];
        setUserId(userId);

        const config = {
            ...EmployeeListService.apiConfig,
            getComponents: false,
            getCompliance: false,
            getBenefits: false,
            customFieldModule: "employee",
        };
        EmployeeListService.apiConfig = config;
        await dispatch(fetchEmployeeDetails(userId))
        getShifts();

        return () => {
            MaskInputUtil.unsubscribe(maskUnmaskObservable);
          }
	}, []);

    useEffect(() => {
		if (userDetails?.user?.reportingManagerName) {
			setReportingManager(userDetails.user.reportingManagerName);
		} else {
			setReportingManager(!TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED) ? NONE_OPTION.name : "");
		}
	}, [userDetails]);

    useEffect(() => {
		if (!Utility.isEmpty(shifts) && !Utility.isEmpty(userId)) {
			const userShift = ShiftUtils.getShiftByUserId(userId, shifts);
			setShiftDetails(userShift);
		}
	}, [shifts, userId]);

    const getShifts = async () => {
		const timeout = showDelayedLoader();
		await dispatch(fetchShifts());
		removeDelayedLoader(timeout);
	};

    const onEditEmployee = () => {
		RouteManager.navigateToPage(PAGE_ROUTES.EMPLOYEE_DETAILS, `&id=${userDetails.user.userId}&isEdit=true&step=0`);
	};

	const getStatus = () => {
		if (!TenantService.get(TENANT.IS_ADMIN)) {
			TenantService.set(TENANT.USER_STATUS, userDetails.user.status);
		}

		return (
			<div className="row flex-wrap">
				<div
					className={`row fs-m  pt-xs pb-xs pl-s pr-s ml-l mr-l border-radius-s ${
						userDetails.user.status === "active"
							? `data-grid-badge-color-6`
							: `data-grid-badge-color-4`
					}  `}
					style={{ width: "auto" }}
				>
					<div
						className=" fs-r text-align-left  display-block "
						style={{ overflowWrap: "break-word" }}
					>
						{userDetails.user.status === "active" ? "Active" : "Inactive"}
					</div>
				</div>
			</div>
		);
	};

	const getIncompleteBadge = () => {
		return (
			<div className="row flex-wrap">
				<div
					className={`row fs-m  pt-xs pb-xs pl-s pr-s border-radius-s data-grid-badge-color-4`}
					style={{ width: "auto" }}
				>
					<div
						className=" fs-r text-align-left display-block"
						style={{ overflowWrap: "break-word" }}
					>
						{"Incomplete Profile"}
					</div>
				</div>
			</div>
		);
	};

    const getIncompleteTooltipText = (incompleteDetails) => {
		let tooltipText = "";
		if (!Utility.isEmpty(incompleteDetails)) {
			tooltipText = `<div><div class='fw-m' style='justify-content:flex-start; padding-top:3px;'>Employee missing fields:</div>${incompleteDetails
				.map(
					(f, i) =>
						`<div class='d-flex fs-s' style='justify-content:flex-start; padding-top:3px'>${
							i + 1
						}. ${getIncompleteFieldName(f)}</div>`
				)
				.join(
					""
				)}</div><div class='' style='justify-content:flex-start; padding-top:3px;'>Please click on <b>Manage Profile</b> to fill the details</div>`;
		}
		return tooltipText;
	};

	return (
        <Fragment>
            {userDetails?.user && (
                <div className="bg-white p-xl border-radius-m border-m row m-v-l">
                    <div className="column parent-width">
                        <div className="row align-items-start mb-m">
                            <div className="column">
                                <DKLabel text={`${userDetails.user.firstName} ${userDetails.user.lastName}`} className="fw-m fs-m mb-s" />
                                <DKLabel text={userDetails.user.designation} className="mb-s" />
                            </div>
                            <div className="column align-self-start">{getStatus()}</div>
                            {!isAdmin && userDetails.user.isInCompleteProfile && (
                                <div className="column align-self-start">{getIncompleteBadge()}</div>
                            )}
                            {!isAdmin &&
                                userDetails.user.isInCompleteProfile &&
                                userDetails.user.inCompleteFields &&
                                userDetails.user.inCompleteFields.length > 0 && (
                                    <div className="column align-self-start">
                                        <DKTooltipWrapper
                                            content={getIncompleteTooltipText(userDetails.user.inCompleteFields)}
                                            tooltipClassName="warning-tooltip-prop warning-tooltip-prop "
                                        >
                                            <DKIcon
                                                src={ic_info_message}
                                                className="ml-s ic-s ml-r mt-xs cursor-hand "
                                                style={{ opacity: 0.4 }}
                                            />
                                        </DKTooltipWrapper>
                                    </div>
                                )}
                            <div className="column align-self-start" style={{ marginLeft: "auto" }}>
                                <div className="row">
                                    {userDetails.user.iamUserId === TenantService.get(TENANT.IAM_USER_ID) && (
                                        <DKButton
                                            title={"Manage Profile"}
                                            className={"dk-bg-button text-white fs-r"}
                                            onClick={() => {
                                                onEditEmployee();
                                            }}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-start">
                            <div className="column mr-xxl">
                                <DKLabel text={t("PW_BASIC_SALARY")} className="mb-s" />
                                <DKLabel text={getCompensation(mask, userDetails.user)} className="fw-m fs-b" />
                            </div>
                            <div className="column ml-xxl pl-xxl">
                                <DKLabel text="Employee Id" className="mb-s pl-l" />
                                <DKLabel text={userDetails.user.employeeId} className="fw-m mb-s pl-l" />
                            </div>
                            {reportingManager && 
                                <div className="column ml-xxl pl-xxl">
                                    <DKLabel text="Direct Manager Name" className="mb-s pl-l" />
                                    <DKLabel text={reportingManager} className="fw-m mb-s pl-l" />
                                </div>
                            }
                            {isShiftManagementEnabled &&
                                !Utility.isEmpty(shiftDetails) &&
                                !isModuleRestricted(
                                    moduleAccessControl,
                                    MODULE_ACCESS.SHIFT_MANAGEMENT
                                ) && (
                                    <div className="column ml-xxl pl-xxl">
                                        <div className="row">
                                            <DKLabel
                                                text={`${t("ASSIGNED_SHIFT")} `}
                                                className="mb-s pl-l"
                                            />
                                            <div
                                                className="font-weight-12 fw-b text-app mb-r cursor-hand"
                                                onClick={() => {
                                                    ShiftManagementService.SHIFT = shiftDetails;
                                                    ShiftManagementService.IS_SHIFT_VIEW = true;
                                                    ShiftManagementService.SELECTED_SHIFT_USER_ID = userId;
                                                    RouteManager.navigateToPage(`${PAGE_ROUTES.ADD_SHIFT}?id=${shiftDetails?.id}&isViewMode=true`);
                                                }}
                                            >
                                                <u>{t("VIEW_DETAILS")}</u>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <DKLabel
                                                text={`${shiftDetails.name} `}
                                                className="fw-m mb-s pl-l"
                                            />
                                            <div className="mb-s">
                                                {`(${ShiftUtils.convert24HrsTimeTo12Hrs(
                                                    shiftDetails.from
                                                )} - ${ShiftUtils.convert24HrsTimeTo12Hrs(
                                                    shiftDetails.to
                                                )})`}
                                            </div>
                                        </div>
                                    </div>
                                )}
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
	);
}

export default UserDetails;
